/**
 * True when the current document supports `Element.prototype.moveBefore`.
 * Safari and older Firefox do not; calling `appendChild` instead would reload
 * descendant iframes, so callers must take a different path.
 */
export const isMoveBeforeSupported = (): boolean => {
	if (typeof Element === 'undefined') {
		return false;
	}
	// `moveBefore` is newer than the DOM lib types, so it is read through a type
	// that admits it rather than asserted onto Element.
	const proto: Element & { moveBefore?: unknown } = Element.prototype;
	return typeof proto.moveBefore === 'function';
};
